// @flow
import {
  USER_TEMPLATES_LOAD,
  USER_TEMPLATES_SAVE,
  USER_TEMPLATES_DELETE,
} from 'actions/userTemplates';
import type { Feature2D, Bbox } from 'flow-geojson';

export type UserTemplate = {
  ...Feature2D,
  id: string | number,
  properties: {
    +name: boolean,
    +saved: string,
    +properties: Object,
    +bbox: Bbox,
  },
};

export type State = {|
  +templates: Array<UserTemplate>,
|};

const INITIAL_STATE: State = {
  templates: [],
};

export default function reduce(
  state: State = INITIAL_STATE,
  { type, ...payload }
) {
  switch (type) {
    case USER_TEMPLATES_LOAD: {
      const { templates } = payload;
      return {
        ...state,
        templates,
      };
    }

    case USER_TEMPLATES_SAVE: {
      const { template } = payload;
      return {
        ...state,
        templates: [...state.templates, template],
      };
    }

    case USER_TEMPLATES_DELETE: {
      const { id } = payload;
      return {
        ...state,
        templates: state.templates.filter(f => f.id !== id),
      };
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/userTemplates.js